import { store } from 'react-notifications-component';

import LocalStrings from '../../../languages';

export const showSuccess = message => {
  store.addNotification({
    title: LocalStrings.toast_message_success,
    message: `${message}`,
    type: 'success',
    insert: 'top',
    container: 'top-center',
    dismiss: {
      duration: 3000,
      onScreen: true,
      click: true,
      pauseOnHover: true
    }
  });
};

export const showError = message => {
  store.addNotification({
    title: LocalStrings.toast_message_error,
    message: `${message}`,
    type: 'danger',
    insert: 'top',
    container: 'top-center',
    dismiss: {
      duration: 3000,
      onScreen: true,
      click: true,
      pauseOnHover: true
    }
  });
};

export const showWarning = message => {
  store.addNotification({
    title: LocalStrings.toast_message_warning,
    message: `${message}`,
    type: 'warning',
    insert: 'top',
    container: 'top-center',
    dismiss: {
      duration: 3000,
      onScreen: true,
      click: true,
      pauseOnHover: true
    }
  });
};

export const showToast = message => {
  store.addNotification({
    title: LocalStrings.toast_message_cheers,
    message: `${message}`,
    type: 'default',
    insert: 'top',
    container: 'top-center',
    dismiss: {
      duration: 3000,
      onScreen: true,
      click: true,
      pauseOnHover: true,
      showIcon: true
    }
  });
};
